/* eslint-disable camelcase */
import { SEO_SUFFIX_EN } from './src/utils/SEO';

const seoEn = {
  title: `App Masters - ${SEO_SUFFIX_EN}`,
  description:
    'Custom app and software development company specializing in AI agents, intelligent automations, web and mobile solutions.',
  openGraph: {
    type: 'website',
    locale: 'en',
    url: `${process.env.NEXT_PUBLIC_SITE_URL}en` || 'http://localhost:3000',
    site_name: 'App Masters',
    images: [
      {
        url: `${process.env.NEXT_PUBLIC_SITE_URL}appmasters-metaimage.png`,
        width: 800,
        height: 600,
        alt: 'App Masters Logo',
      },
    ],
  },
};

export default seoEn;
